module.exports = __webpack_public_path__ + "static/img/beigne.4d68586.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/world/elements/img/cursor/beigne.png
// module id = cAKA
// module chunks = 0